import { useMemo } from 'react';
import type { ItemFiltersType } from '@/lib/api/types/itemFilters';
import { useItemTypesQuery } from '@/lib/queries/common/useItemTypesQuery';

export const useTimelineItemTypeFilter = (itemLevelId?: number | null, enabled = true) => {
  const { data: itemTypesWithCurLevelId } = useItemTypesQuery({
    enabled,
    select: (data) => {
      if (!itemLevelId) {
        return data;
      }
      return data.filter((itemType) => itemType.itemLevelId === itemLevelId);
    },
  });

  const itemTypeFilter: ItemFiltersType = useMemo(() => {
    if (!itemLevelId || !itemTypesWithCurLevelId || itemTypesWithCurLevelId.length === 0) {
      return {};
    }

    return {
      itemTypeId: {
        operator: 'in',
        value: itemTypesWithCurLevelId.map((itemType) => itemType.id),
      },
    };
  }, [itemLevelId, itemTypesWithCurLevelId]);

  return {
    itemTypeFilter,
  };
};
